export default {
    list: [], // 공급내역
    providerInfo: {}, // 공급자
    consumerInfo: {}, // 공급받는 자
};
